import { render, staticRenderFns } from "./flowView.vue?vue&type=template&id=6bf5ea70&scoped=true"
import script from "./flowView.vue?vue&type=script&lang=js"
export * from "./flowView.vue?vue&type=script&lang=js"
import style0 from "./flowView.vue?vue&type=style&index=0&id=6bf5ea70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf5ea70",
  null
  
)

export default component.exports